import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguageCode } from '../utils/getURLParams';
import commonTranslationsDE from './de/common.json';
import commonTranslationsEN from './en/common.json';
import commonTranslationsUS from './us/common.json';

const resources = {
  en: {
    common: commonTranslationsEN,
  },
  de: {
    common: commonTranslationsDE,
  },
  us: {
    common: commonTranslationsUS,
  },
};

const lang = getLanguageCode("Atd");

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    resources,
    lng: lang || 'en',
    react: {
      useSuspense: false,
    },
  });

export default i18n;
